<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_DownImportTemplate')"
    width="385px"
    :close-on-click-modal="false"
    class="download-import-template"
  >
    <div class="border">
      <div
        :style="{
          width: $selectByLang('55px', '55px', '55px', '140px', '140px', '140px'),
          height: '30px',
          background: 'white',
          marginTop: '-6px',
          marginLeft: '8px'
        }"
      >
        <span>{{ $t('CargoMsg.Cargo_DownloadContent') }}</span>
      </div>
      <div style="margin-left: 25px; color: #848484">
        <div style="font-size: 14.3px; ">
          <el-checkbox disabled checked />{{ ' ' + templateFileName }}
        </div>
        <div style="margin-top: 14px; font-size: 14.3px; ">
          <el-checkbox v-if="sampleFileName" disabled checked />{{ ' ' + sampleFileName }}
        </div>
      </div>
    </div>
    <div style="height: 60px">
      <div style="margin-top: 15px; font-weight: 800; vertical-align: top; display: inline-block">{{ $t('Message.Explain') }}</div>
      <div style="margin-top: 15px; margin-left: 2px; display: inline-block; color: #848484">
        <div>{{ templateFileName + $t('CargoMsg.Cargo_ImportOrderTemplateFile') }}</div>
        <div v-if="sampleFileName" style="margin-top: 10px">{{ sampleFileName + $t('CargoMsg.Cargo_ImportOrderTemplateDataSampleFile') }}</div>
      </div>
    </div>
    <span slot="footer">
      <el-button style="background-color: #006dbf; color: white" no="download" @click="download()">{{ $t('CargoMsg.Cargo_Download') }}</el-button>
      <el-button style="background-color: #d7f5ff; color: #479ad2; border-color: #2281c8" no="cancel" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getOrderTemplateConfig } from '@/api/sysManage/baseConfig/importOrderTemplate'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { getOrderTemplateSample } from '@/api/sysManage/baseConfig/importOrderTemplateSample'
import { cache, cacheName } from '@/utils/cacheManager'
import URL from '@/api/urlTranslator'

export default {
  name: 'DownloadImportTemplateDialog',
  props: {
    visible: { type: Boolean, required: true },
    lob: { type: String, required: true } // 业务类型
  },
  data() {
    return {
      innerVisible: this.visible,
      branchId: this.$store.getters.currentOfficeId,
      templateFileName: '',
      sampleFileName: '',
      sampleFileId: '',
      storageURL: ''
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.onShow()
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
    await this.onShow()
  },
  methods: {
    async onShow() {
      await getOrderTemplateConfig({ branchId: this.branchId, lob: this.lob }).then(res => {
        this.templateFileName = res.data.name
      })
      await getOrderTemplateSample({ branchId: this.branchId, lob: this.lob }).then(async res => {
        if (res.data) {
          this.sampleFileName = res.data.sampleFileName.slice(0, -5)
          this.sampleFileId = res.data.sampleFileId
        }
      })
    },
    async download() {
      // 下载导出订单模板
      ExportUtils.downloadOrderTemplateFile(this.$store.getters.currentOfficeId, this.lob)
      // 下载样例模板
      if (this.sampleFileId) {
        this.downloadFile(this.sampleFileId)
      }
      this.innerVisible = false
    },
    // 下载文件
    downloadFile(fileId) {
      const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
      window.open(url, '_self')
    }
  }
}
</script>

<style scoped lang="scss">
.download-import-template {
  .border {
    width: 360px;
    height: 93px;
    margin-top: 10px;
    border: 2px solid #888888;
  }
  .el-checkbox__label {
    padding-left: 2px;
  }
}
</style>
